import { createFileRoute } from '@tanstack/react-router'
import { BillingOverviewPage } from '@/features/account/pages/billing/billing-overview-page'

export interface BillingSearch {
  /** C3 buy-topup overlay (BuyTopupDialog) — seats or credits. */
  buy?: 'seats' | 'credits'
}

/** C1 — Billing overview (C3 buy-topup rides as a `?buy` overlay). */
export const Route = createFileRoute('/_ws/w/$workspaceId/seats-billing/billing')({
  validateSearch: (search: Record<string, unknown>): BillingSearch => ({
    buy: search.buy === 'seats' || search.buy === 'credits' ? search.buy : undefined,
  }),
  component: BillingOverviewPage,
})
